module.exports = __webpack_public_path__ + "img/E263.96a21fee.svg";